import { BaseText, Button } from 'aimo-ui';
import useUpdateParkingMutation from 'hooks/useUpdateParkingMutation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { ColumnWithMargins } from 'styles/ContainerStyles';

const Container = styled.View`
  gap: 15px;
  margin-bottom: 15px;
`;

type CancelParkingChargingProps = {
  cancelChargingLoading: boolean;
  cancelChargingSession: () => void;
  parkingSessionId: string;
};

const CancelParkingCharging: React.FC<CancelParkingChargingProps> = ({
  cancelChargingLoading,
  cancelChargingSession,
  parkingSessionId,
}) => {
  const { t } = useTranslation();

  const { updateParking, updateParkingLoading } = useUpdateParkingMutation({
    sessionId: parkingSessionId,
    actionType: 'STOP',
    isModal: true,
  });

  const handleStopParkingAndChargingSessions = () => {
    cancelChargingSession();
    updateParking();
  };

  const loading = cancelChargingLoading || updateParkingLoading;
  return (
    <Container>
      <ColumnWithMargins mb={10}>
        <BaseText>{t('evCharging.cancelAlso')}</BaseText>
      </ColumnWithMargins>
      <Button
        size="l"
        testID="charging-parking-stop-confirm"
        buttonType="secondary"
        text={t('evCharging.cancelParkAndCharge')}
        onPress={handleStopParkingAndChargingSessions}
        loading={loading}
        disabled={loading}
      />
      <Button
        size="l"
        testID="charging-cancel"
        buttonType="tertiary"
        text={t('evCharging.cancelChargingOnly')}
        onPress={cancelChargingSession}
        loading={loading}
        disabled={loading}
      />
    </Container>
  );
};

export default CancelParkingCharging;
